import { dropNoiseRumEvents } from '@/Domain/helper/datadogRumFilter';

export const DATADOG_RUM_SDK_URL = 'https://www.datadoghq-browser-agent.com/eu1/v5/datadog-rum.js';

export interface DatadogRumBootConfig {
  version: string;
  dd_env: string;
}

export function initDatadogRum(config: DatadogRumBootConfig): void {
  if (config.dd_env !== 'prod') return;
  const rumScript = document.createElement('script');
  rumScript.src = DATADOG_RUM_SDK_URL;
  rumScript.async = true;
  rumScript.onload = () => {
    window.DD_RUM?.init({
      clientToken: 'pub5de2760b59baac71d29e8c4e3199929a',
      applicationId: 'd93e3e82-391c-403d-b460-dabf0bcee15f',
      site: 'datadoghq.eu',
      service: 'app-quickchat',
      version: config.version,
      env: config.dd_env,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'allow',
      beforeSend: dropNoiseRumEvents,
    });
    window.DD_RUM?.startSessionReplayRecording();
  };
  document.head.appendChild(rumScript);
}
